import {USStateCode, usStateCodes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../entity/base-db-code-select";

type Props = DbCodeSelectProps<USStateCode>;

export const USStateSelect = (props: Props) => {
  const {options = usStateCodes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
